
import { defineComponent, PropType } from 'vue'
import { formatIntl, shortenLargeNumber } from '~/utils/string'
import { severityIconMap } from '~/utils/dependencies'
import { VulnerabilitySeverity } from '~/types/types'
import { FilterType } from '~/types/active3rdPartyVuln'
import { SEVERITY_MAPPINGS, REACHABILITY_MAPPINGS } from '~/utils/active3rdPartyVuln'

export default defineComponent({
  name: 'VulnerabilityStatCard',
  props: {
    slug: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    filterType: {
      type: String as PropType<FilterType>,
      default: FilterType.SEVERITY
    }
  },
  methods: {
    formatIntl,
    shortenLargeNumber,

    getIcon(slug: string): string {
      if (this.filterType === FilterType.SEVERITY) {
        const slugToSeverityMap: Record<string, VulnerabilitySeverity> = {
          cri: VulnerabilitySeverity.Critical,
          hig: VulnerabilitySeverity.High,
          med: VulnerabilitySeverity.Medium,
          low: VulnerabilitySeverity.Low
        }
        const severity = slugToSeverityMap[slug]
        return severity ? severityIconMap[severity]?.icon || 'circle' : 'circle'
      } else {
        return (
          REACHABILITY_MAPPINGS[slug as keyof typeof REACHABILITY_MAPPINGS]?.icon ||
          'map-pin-dash-inside'
        )
      }
    },

    getDisplayName(slug: string, filterType: FilterType): string {
      if (filterType === FilterType.SEVERITY) {
        return SEVERITY_MAPPINGS[slug as keyof typeof SEVERITY_MAPPINGS] || slug
      } else {
        return REACHABILITY_MAPPINGS[slug as keyof typeof REACHABILITY_MAPPINGS]?.name || slug
      }
    }
  }
})
